import SelectMenu from "../../../controls/SelectMenu";
import type {
  FinanceReportFilters,
  ReportFilterOption,
  SetFinanceReportFilters,
  WorkOrderFilterOption,
} from "./types";

type Props = {
  filters: FinanceReportFilters;
  roomEntityLabel: string;
  rooms: ReportFilterOption[];
  setFilters: SetFinanceReportFilters;
  wipsEntityLabel: string;
  workOrders: WorkOrderFilterOption[];
};

export default function FieldCostsFilters({
  filters,
  roomEntityLabel,
  rooms,
  setFilters,
  wipsEntityLabel,
  workOrders,
}: Props) {
  const selectedRoomId = Number(filters.room.value);
  const availableWorkOrders =
    selectedRoomId > 0
      ? workOrders.filter((workOrder) => workOrder.room_id === selectedRoomId)
      : workOrders;
  const selectedWorkOrders = availableWorkOrders.filter((workOrder) =>
    filters.work_orders.includes(workOrder.value),
  );

  const updateRoom = (room: ReportFilterOption) => {
    const roomId = Number(room.value);
    const compatibleWorkOrderIds = new Set(
      workOrders
        .filter((workOrder) => roomId <= 0 || workOrder.room_id === roomId)
        .map((workOrder) => workOrder.value),
    );

    setFilters({
      ...filters,
      room,
      work_orders: filters.work_orders.filter((id) =>
        compatibleWorkOrderIds.has(id),
      ),
    });
  };

  return (
    <div className="grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2">
      <SelectMenu
        title={roomEntityLabel}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          updateRoom(event.target.value)
        }
        name="room"
        options={rooms}
        value={filters.room}
      />
      <SelectMenu
        title={wipsEntityLabel}
        handleInputChange={(event: {
          target: { value: WorkOrderFilterOption[] | null };
        }) =>
          setFilters({
            ...filters,
            work_orders: (event.target.value ?? []).map(({ value }) => value),
          })
        }
        isClearable
        isMulti
        name="work_orders"
        options={availableWorkOrders}
        placeholder={`All ${wipsEntityLabel.toLowerCase()}`}
        value={selectedWorkOrders}
      />
    </div>
  );
}
